import React, { FC } from "react";
import { CardActions as MuiCardActions, CardActionsProps } from "@mui/material";

const CardActions: FC<CardActionsProps> = (props) => <MuiCardActions {...props} />;

export default CardActions;
